import { gql } from '@apollo/client';

const GET_BOOK = gql`
  query book($bookWhere: BookWhereInput!) {
    book(where: $bookWhere) {
      id
      type
      title
      bookCode
      orientation
      edition
      totalPages
      path
      locale
      pages {
        id
        pageNumber
        src
      }
      offset
      characters {
        id
        character
        characterType
        characterCase
      }
    }
  }
`;

export default GET_BOOK;
